// import * as utils from '@/utils/utils';

import services from '../services/dataSource.js'

const {
  getSelectData,
  getProvinceList,
  getCityList,
  getContractingType,
  getNotice,
  getAreaList,
  getGroupMemberList,
  getUnitMemberList,
  get3aMemberList,
  getNoticeDetail,
} = services

const namespace = 'dataSource'

export default {
  namespace,
  state: {
    // 注册企业类型
    registeredList: [],
    // 所属协会
    associationList: [],
    // 太难改了，只预留一个页面同时出现三个selector的可能
    // 省
    provinceList0: [],
    // 市
    cityList0: [],
    // 区
    areaList0: [],
    provinceList1: [],
    cityList1: [],
    areaList1: [],
    provinceList2: [],
    cityList2: [],
    areaList2: [],
    // 总承包企业资质类型
    generalContractingList: [],
    // 专业承包企业资质等级
    specializedContractingList: [],
    // 其他企业类型
    otherBusinessTypes: [],
    // 会员类型
    memberTypeList: [],
    // 上报文件类型
    reportFileType: [
      {
        label: '营业执照',
        value: 106,
      },
      {
        label: '资质证书',
        value: 107,
      },
      {
        label: '入户申请',
        value: 108,
      },
    ],

    // 文件公告
    noticeList: {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: [],
    },

    noticeDetail: {
      title: '',
      content: '',
    },

    // 会员服务信息
    newsList: {
      list: [],
    },

    // 会员名录
    memberDirectory: {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: [],
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *changeLogin({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 注册企业类型
    *getEnterpriseType({ payload, callback }, { call, put }) {
      const res = yield call(getSelectData, { type: 0 })
      yield put({
        type: 'updateState',
        payload: { registeredList: res.data.selectList },
      })
    },

    // 省
    *getProvinceList({ payload, callback }, { call, put }) {
      const res = yield call(getProvinceList, { ...payload })
      const index = payload?.index ?? 0
      yield put({
        type: 'updateState',
        payload: { ['provinceList' + index]: res.data.regionlist },
      })
      callback && callback(res.data.regionlist)
    },

    // 市
    *getCityList({ payload, callback }, { call, put, select }) {
      const res = yield call(getCityList, { ...payload })
      const index = payload.index ?? 0
      yield put({
        type: 'updateState',
        payload: { ['cityList' + index]: res.data.regionlist },
      })
      callback && callback(res.data.regionlist)
    },

    // 区
    *getAreaList({ payload, callback }, { call, put, select }) {
      const res = yield call(getAreaList, { ...payload })
      const index = payload.index ?? 0
      yield put({
        type: 'updateState',
        payload: { ['areaList' + index]: res.data.regionlist },
      })
      callback && callback(res.data.regionlist)
    },

    // 所属协会
    *getAssociationList({ payload, callback }, { call, put, select }) {
      const res = yield call(getSelectData, { type: 1 })
      yield put({
        type: 'updateState',
        payload: { associationList: res.data.selectList },
      })
    },

    // 会员类型
    *getMemberTypeList({ payload, callback }, { call, put, select }) {
      const res = yield call(getSelectData, { type: 3 })
      yield put({
        type: 'updateState',
        payload: { memberTypeList: res.data.selectList },
      })
    },

    // 总承包企业资质类型
    *getGeneralContractingList({ payload, callback }, { call, put, select }) {
      const res = yield call(getContractingType, { type: 0 })
      yield put({
        type: 'updateState',
        payload: { generalContractingList: res.data },
      })
    },

    // 专业承包企业资质等级
    *getSpecializedContractingList({ payload, callback }, { call, put, select }) {
      const res = yield call(getContractingType, { type: 1 })
      yield put({
        type: 'updateState',
        payload: { specializedContractingList: res.data },
      })
    },

    // 其他企业类型
    *getOtherBusinessTypes({ payload, callback }, { call, put, select }) {
      const res = yield call(getSelectData, { type: 2 })
      yield put({
        type: 'updateState',
        payload: { otherBusinessTypes: res.data.selectList },
      })
    },

    // 获取公告信息
    *getNotice({ payload, callback }, { call, put, select }) {
      const res = yield call(getNotice, payload)
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            noticeList: res.data,
          },
        })
      }
    },

    // 获取会员服务信息信息
    *getNews({ payload, callback }, { call, put, select }) {
      const res = yield call(getNotice, payload)
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            newsList: res.data,
          },
        })
      }
    },

    // 获取公告详情
    *getNoticeDetail({ payload, callback }, { call, put, select }) {
      const res = yield call(getNoticeDetail, payload)
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            noticeDetail: res.data,
          },
        })
        callback && callback(res.data)
      }
    },

    // 团体会员列表
    *getGroupMemberList({ payload, callback }, { call, put, select }) {
      const res = yield call(getGroupMemberList, payload)
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { memberDirectory: res.data },
        })
      }
    },

    // 单位会员列表
    *getUnitMemberList({ payload, callback }, { call, put, select }) {
      const res = yield call(getUnitMemberList, payload)
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { memberDirectory: res.data },
        })
      }
    },

    // 单位会员列表
    *get3aMemberList({ payload, callback }, { call, put, select }) {
      const res = yield call(get3aMemberList, payload)
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { memberDirectory: res.data },
        })
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
